import {inject, Injectable} from '@angular/core';
import {
  ButtonRecordValue,
  ParentInfoUpdateParams,
  RecordData,
  RecordDataValue,
  RecordTableColumnParams
} from '../types/records-table.types';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {RecordsTableService} from './records-table.service';
import {CloseModalReason} from '../types/modal.types';
import {RepeatsModalComponent} from '../components/modals/repeats-modal/repeats-modal.component';
import {ContactsModalComponent} from "../components/modals/contacts-modal/contacts-modal.component";
import {AddCooperationOfferComponent} from "../components/modals/add-cooperation-offer/add-cooperation-offer.component";
import {AddUserModalComponent} from "../components/modals/add-user-modal/add-user-modal.component";
import {ChangePasswordModalComponent} from '../components/modals/change-password-modal/change-password-modal.component';
import {DocumentsModalComponent} from '../components/modals/documents-modal/documents-modal.component';
import {BankDetailsModalComponent} from "../components/modals/bank-details-modal/bank-details-modal.component";
import {ChangelogModalComponent} from "../components/modals/changelog-modal/changelog-modal.component";
import {HistoryChangesModalComponent} from "../components/modals/history-changes-modal/history-changes-modal.component";
import {
  OpenHistoryChangesModalParams
} from "../components/modals/history-changes-modal/types/history-changes-modal.types";
import {EditAudienceModalComponent} from "../components/modals/edit-audience-modal/edit-audience-modal.component";
import {BloggerCardModalParams} from "../components/modals/blogger-modals/types/blogger-deduplication-modal.types";
import {
  BloggerDeduplicationModalComponent
} from "../components/modals/blogger-modals/blogger-deduplication-modal/blogger-deduplication-modal.component";
import {
  AdvertisementPackagesModalComponent
} from "../components/modals/advertisement-packages-modal/advertisement-packages-modal.component";
import {ResourceParams} from "../models/resource/resources";
import {
  AddTelegramAccountModalComponent
} from "../components/modals/add-telegram-account-modal/add-telegram-account-modal.component";
import {
  TelegramChatModalComponent
} from "../../features/pages/telegram-page/components/modals/telegram-chat-modal/telegram-chat-modal.component";
import {
  TelegramAttachAllAdvertsModalComponent
} from "../components/modals/telegram-attach-all-adverts-modal/telegram-attach-all-adverts-modal.component";
import {
  SingleTypeFilesViewerModalComponent
} from "../components/modals/files-modal/single-type-files-viewer-modal/single-type-files-viewer-modal.component";
import {
  MultiTypeFilesViewerModalComponent
} from "../components/modals/files-modal/multi-type-files-viewer-modal/multi-type-files-viewer-modal.component";
import {OpenFilesViewerModalParams} from "../types/file.types";
import {
  PreviewFileModalComponent
} from "../components/modals/files-modal/preview-file-modal/preview-file-modal.component";
import {PreviewFileDialogData} from "../components/modals/files-modal/types/preview-file-modal.types";
import {HypothesisModalComponent} from "../components/modals/hypothesis-modal/hypothesis-modal.component";
import {
  BloggerMassOfferModalComponent
} from "../components/modals/blogger-modals/blogger-mass-offer-modal/blogger-mass-offer-modal.component";
import {CustomerModalComponent} from "../components/modals/customer-modal/customer-modal.component";
import {FeedbackMediaModalComponent} from "../components/modals/feedback-media-modal/feedback-media-modal.component";
import {
  PreviewFileHlsModalComponent
} from "../components/modals/files-modal/preview-file-hls-modal/preview-file-hls-modal.component";
import {
  BloggerProfileModalComponent
} from "../components/modals/blogger-modals/blogger-profile-modal/blogger-profile-modal.component";
import {
  TelegramChatHistoryComponent
} from "../../features/pages/telegram-page/components/modals/telegram-chat-history/telegram-chat-history.component";
import {LineChartModalComponent} from "../components/modals/line-chart-modal/line-chart-modal.component";
import {LineChartDialogData} from "../components/modals/line-chart-modal/types/line-chart-modal.types";
import {ProductCardModalComponent} from "../components/modals/product-card-modal/product-card-modal.component";
import {DefectsModalComponent} from "../components/modals/defects-modal/defects-modal.component";
import {SettingsTableModalComponent} from "../components/modals/settings-table-modal/settings-table-modal.component";
import {SettingsTableDialogData} from "../components/modals/settings-table-modal/types/settings-table.types";
import {UploadExcelModalComponent} from "../components/modals/upload-excel-modal/upload-excel-modal.component";
import {UploadExcelDialogData} from "../components/modals/upload-excel-modal/types/upload-excel-modal.types";
import {ProfileColumnModalComponent} from "../components/modals/profile-column-modal/profile-column-modal.component";
import {ProfileColumnDialogData} from "../components/modals/profile-column-modal/types/profile-column-modal.types";
import {
  ItemPasteProgressModalComponent
} from "../components/modals/item-paste-progress-modal/item-paste-progress-modal.component";
import {
  ItemPasteProgressDialogData
} from "../components/modals/item-paste-progress-modal/types/item-paste-progress-modal.types";
import {
  NoteFilesModalComponent
} from "../../features/pages/notes-page/components/modals/note-files-modal/note-files-modal.component";
import {
  technicalParameterModalConfig
} from "../../features/pages/product-card-page/configs/product-card-technical-parameter-config";
import {
  designBlockFilesModalConfig,
  designBlocksModalConfig
} from "../../features/pages/product-card-page/configs/product-card-design-blocks-config";
import {
  YandexDataCheckModalComponent
} from "../components/modals/yandex-data-check-modal/yandex-data-check-modal.component";
import {
  marketingBlocksModalConfig
} from "../../features/pages/product-card-page/configs/product-card-marketing-blocks-config";
import {EditorTextModalComponent} from "../components/modals/editor-text-modal/editor-text-modal.component";
import {EditorTextModalDialogData} from "../components/modals/editor-text-modal/types/editor-text-modal.types";
import {
  statisticsModalConfig
} from "../components/records-table/record-table-items/modal-record-table-item/configs/statistics-modal-config";
import {bloggerGroupModalConfig} from "../components/modals/blogger-groups-modals/configs/blogger-groups-config";
import {noteModalConfig} from "../../features/pages/notes-page/configs/notes-page-modals-config";
import {
  productPackagesModalConfig
} from "../../features/pages/product-packages-page/configs/product-packages-modal-config";
import {
  competitorBrandsModalConfig
} from "../../features/pages/competitor-brands-page/configs/competitor-brands-modal-config";
import {priceLevelsModalConfig} from "../../features/pages/price-levels-page/configs/price-levels-page-modals-config";
import {
  priceLevelConfigsModalConfig
} from "../../features/pages/price-level-configs-page/configs/price-level-configs-page-modals-config";
import {BaseConfirmModalComponent} from "../components/modals/base-confirm-modal/base-confirm-modal.component";
import {DeleteConfirmationParams} from "../types/confirmation-modal.types";
import {
  TestingResultFilesModalComponent
} from "../../features/pages/product-card-page/components/modals/testing-result-files-modal/testing-result-files-modal.component";
import {
  CreateComponentModalComponent
} from "../../features/pages/product-card-page/components/modals/create-component-modal/create-component-modal.component";
import {
  CreateTestingResultModalComponent
} from "../../features/pages/product-card-page/components/modals/create-testing-result-modal/create-testing-result-modal.component";
import {
  PriceLevelConfigCopyModalComponent
} from "../../features/pages/price-level-configs-page/components/modals/price-level-config-copy-modal/price-level-config-copy-modal.component";
import {
  PriceLevelConfigCopyDialogData
} from "../../features/pages/price-level-configs-page/components/modals/price-level-config-copy-modal/types/price-level-config-copy.types";
import {
  qualityControlModalConfig
} from "../../features/pages/product-card-page/configs/product-card-quality-control-config";
import {
  wildberriesProductCardsModalConfig
} from "../../features/pages/wildberries-product-cards-page/configs/wildberries-product-cards-modal-config";
import {
  ChangeRrcLimitModalComponent
} from "../../features/pages/rrc-limits-page/components/modals/change-rrc-limit-modal/change-rrc-limit-modal.component";
import {
  RrcLimitsCopyModalComponent
} from "../../features/pages/rrc-limits-page/components/modals/rrc-limitms-copy-modal/rrc-limits-copy-modal.component";
import {
  RrcLimitCopyDialogData
} from "../../features/pages/rrc-limits-page/components/modals/rrc-limitms-copy-modal/types/rrc-limits-copy-config.types";

@Injectable({
  providedIn: 'root'
})
export class ModalsService {
  private dialog: MatDialog = inject(MatDialog);
  private recordsTableService: RecordsTableService = inject(RecordsTableService);

  public async getStatusFromAudienceModal(columnParamKey: string, recordData: RecordData): Promise<CloseModalReason> {
    const audienceParamsId = recordData['audienceId'] ?? null;
    let updateParentInfo: ParentInfoUpdateParams | null = this.getParentInfoUpdateParams(columnParamKey, recordData);

    const dialogRef = this.dialog.open(EditAudienceModalComponent, {
      data: {
        audienceParamsId,
        updateParentInfo
      },
      width: '900px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public getStatusFromContactModal(columnParamKey: string, recordData: RecordData, fromBloggerProfile: boolean = false): Promise<CloseModalReason> | void {
    const alreadyOpenedDialog: MatDialogRef<any> | undefined = this.dialog.getDialogById(columnParamKey);
    if (alreadyOpenedDialog) { return; }

    const bloggerId = fromBloggerProfile ? (recordData['blogger'] as RecordData).id : (recordData['bloggerContact'] as RecordData)?.['bloggerId'];
    const dialogRef = this.dialog.open(ContactsModalComponent, {
      data: {
        recordData: recordData,
        bloggerId: bloggerId,
        recordCalendarId: (recordData['bloggerContact'] as RecordData)?.['recordCalendarId'],
        parentPath: this.recordsTableService.getCurrentResourceType().path,
        fromBloggerProfile: fromBloggerProfile
      }
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public getStatusFromBloggerCardModal(bloggerCardModalParams: BloggerCardModalParams): Promise<CloseModalReason> | void {
    const { columnParamKey, columnParam, recordData, path } = bloggerCardModalParams;
    const alreadyOpenedDialog: MatDialogRef<any> | undefined = this.dialog.getDialogById(columnParamKey);
    if (alreadyOpenedDialog) { return; }

    const dialogRef = this.dialog.open(BloggerProfileModalComponent, {
      data: {
        recordData,
        columnParam,
        parentResourceId: (recordData['blogger'] as RecordData)['recordCalendarId'],
        parentResourcePath: path,
        bloggerId: (recordData['blogger'] as RecordData).id,
        audienceId: recordData['audienceId'],
      },
      width: '1030px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openRepeatsModal(recordData: RecordData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(RepeatsModalComponent, {
      data: { recordData },
      width: "810px"
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openCooperationOffer(): MatDialogRef<AddCooperationOfferComponent> {
    return this.dialog.open(AddCooperationOfferComponent);
  }

  public openAddUserModal(): MatDialogRef<AddUserModalComponent> {
    return this.dialog.open(AddUserModalComponent);
  }

  public openChangePasswordModal(recordData: RecordData): MatDialogRef<ChangePasswordModalComponent> {
    return this.dialog.open(ChangePasswordModalComponent, {
      data: {recordData}
    });
  }

  public openDocumentsModal(recordData: RecordData, resourceParams: ResourceParams): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(DocumentsModalComponent, {
      data: {
        recordData,
        resourceParams
      }
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openAdvertisementStatisticsModal(modalKey: string, recordData: RecordData): Promise<CloseModalReason> | void {
    const config = statisticsModalConfig[modalKey];
    const dialogRef = this.dialog.open(config.component, {
      data: {
        parentRecordData: recordData,
        [config.fieldName]: (recordData[modalKey] as RecordData).id,
        modalKey: modalKey
      },
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openBankDetails(columnParamKey: string, recordData: RecordData, fromBloggerProfile: boolean = false): Promise<CloseModalReason> | void {
    const alreadyOpenedDialog: MatDialogRef<any> | undefined = this.dialog.getDialogById(columnParamKey);
    if (alreadyOpenedDialog) { return; }

    const bloggerId = fromBloggerProfile ? (recordData['blogger'] as RecordData).id : (recordData['bankDetails'] as RecordData)?.['bloggerId'];
    const dialogRef = this.dialog.open(BankDetailsModalComponent, {
      data: {
        recordData: recordData,
        bloggerId: bloggerId,
        fromBloggerProfile: fromBloggerProfile
      }
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openSingleTypeFilesViewerModal(openFilesViewerModalParams: OpenFilesViewerModalParams): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(SingleTypeFilesViewerModalComponent, {
      data: openFilesViewerModalParams,
      width: '450px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openMultiTypeFilesViewerModal(openFilesViewerModalParams: OpenFilesViewerModalParams): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(MultiTypeFilesViewerModalComponent, {
      data: openFilesViewerModalParams,
      width: '450px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openBloggerDeduplicationModal(recordData: RecordData, tableColumnParams?: RecordTableColumnParams): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(BloggerDeduplicationModalComponent, {
      data: {
        currentBlogger: recordData,
        tableColumnParams: tableColumnParams
      },
      width: '500px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openChangelogModal(changelogBack: string, changelogFront: string): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(ChangelogModalComponent, {
      data: {
        changelogBack: changelogBack,
        changelogFront: changelogFront
      },
      width: '1000px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openHistoryChangesModal({ historyChangesData }: OpenHistoryChangesModalParams): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(HistoryChangesModalComponent, {
      data: {
        historyChangesData: historyChangesData
      },
      width: '800px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openAdvertisementPackageModal(columnKey: string, recordData: RecordData): Promise<CloseModalReason> | void  {
    const dialogRef = this.dialog.open(AdvertisementPackagesModalComponent, {
      data: {
        recordData: recordData
      },
      width: '1000px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openTelegramChatModal(recordCalendarId: number): Promise<CloseModalReason> | void  {
    const dialogRef = this.dialog.open(TelegramChatModalComponent, {
      data: {
        recordCalendarId: recordCalendarId
      },
      width: '900px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openAddTelegramAccount(): MatDialogRef<AddTelegramAccountModalComponent> {
    return this.dialog.open(AddTelegramAccountModalComponent);
  }

  public openTelegramAttachAllModal(userId: number, login: RecordDataValue): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(TelegramAttachAllAdvertsModalComponent, {
      data: {
        userId: userId,
        login: login
      }
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openPreviewFileModal(fileUrl: PreviewFileDialogData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(PreviewFileModalComponent, {
      data: fileUrl,
      width: '800px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openBloggerGroupsModal<T>(data: T, modalKey: string): Promise<CloseModalReason> | void {
    const config = bloggerGroupModalConfig[modalKey];
    const dialogRef = this.dialog.open(config.component, {
      data: data,
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openHypothesisModal(recordData: RecordData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(HypothesisModalComponent, {
      data: recordData['hypothesisModal'],
      width: '90vw'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openBloggerMassOffer(bloggerIds: Array<number>): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(BloggerMassOfferModalComponent, {
      data: bloggerIds,
      width: '500px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openCustomerModal(recordData: RecordData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(CustomerModalComponent, {
      data: {
        customer: recordData['customer'],
        feedbackId: recordData.id,
        parentData: recordData
      },
      width: '500px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openFeedbackMediaModal(recordData: RecordData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(FeedbackMediaModalComponent, {
      data: {
        media: recordData['media'],
        feedbackId: recordData.id
      },
      width: '500px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openPreviewFileHlsModal(fileUrl: string): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(PreviewFileHlsModalComponent, {
      data: {
        url: fileUrl
      },
      width: '800px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openTelegramChatHistory(recordDataId: number): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(TelegramChatHistoryComponent, {
      data: recordDataId
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openLineChartModal(data: LineChartDialogData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(LineChartModalComponent, {
      data: data
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openProductCardModal(path: string, parentData: RecordData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(ProductCardModalComponent, {
      data: {
        parentPath: path,
        parentData: parentData
      },
      width: '400vw'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openDefectsModal(recordData: RecordData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(DefectsModalComponent, {
      data: {
        recordData: recordData,
        productCardId: (recordData['productCard'] as ButtonRecordValue).id
      },
      width: '350px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openSettingsTableModal(settingsTableDialogData: SettingsTableDialogData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(SettingsTableModalComponent, {
      data: settingsTableDialogData,
      width: '400px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openUploadExcelModal(uploadExcelDialogData: UploadExcelDialogData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(UploadExcelModalComponent, {
      data: uploadExcelDialogData,
      width: '400px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openProfileColumnModal(profileColumnDialogData: ProfileColumnDialogData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(ProfileColumnModalComponent, {
      data: profileColumnDialogData,
      width: '400px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openNoteFilesModal(recordData: RecordData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(NoteFilesModalComponent, {
      data: {
        noteId: recordData.id
      }
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openItemPasteProgressModalComponent(itemPasteProgressDialogData: ItemPasteProgressDialogData): Promise<CloseModalReason> | void  {
    const dialogRef = this.dialog.open(ItemPasteProgressModalComponent, {
      data: itemPasteProgressDialogData,
      width: '400px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openTechnicalParameterModal(recordData: RecordData, modalKey: keyof typeof technicalParameterModalConfig): Promise<CloseModalReason> | void {
    const config = technicalParameterModalConfig[modalKey];
    const dialogRef = this.dialog.open(config.component, {
      data: {
        parentId: recordData.id,
        [config.fieldName]: recordData[config.fieldName],
        modalKey: modalKey
      },
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openDesignBlocksModal(recordData: RecordData, modalKey: keyof typeof designBlocksModalConfig): Promise<CloseModalReason> | void {
    const config = designBlocksModalConfig[modalKey];
    const dialogRef = this.dialog.open(config.component, {
      data: {
        parentId: recordData.id,
        [config.fieldName]: recordData[config.fieldName],
        modalKey: modalKey
      },
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openDesignBlockFilesModal(recordData: RecordData, modalKey: keyof typeof designBlockFilesModalConfig): Promise<CloseModalReason> | void {
    const config = designBlockFilesModalConfig[modalKey];
    const dialogRef = this.dialog.open(config.component, {
      data: {
        parentId: recordData.id,
        [config.fieldName]: recordData[config.fieldName],
        modalKey: modalKey
      },
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openNoteModal(recordData: RecordData, columnKey: string, parentPath: string): Promise<CloseModalReason> | void {
    const config = noteModalConfig[columnKey];
    const dialogRef = this.dialog.open(config.component, {
      data: {
        parentData: recordData,
        parentPath: parentPath,
        keyModal: columnKey
      },
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openYandexDataCheckModal(recordData: RecordData, parentPath: string): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(YandexDataCheckModalComponent, {
      data: {
        parentData: recordData,
        parentPath: parentPath
      },
      width: '450px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openMarketingBlocksModal(recordData: RecordData, modalKey: keyof typeof marketingBlocksModalConfig): Promise<CloseModalReason> | void {
    const config = marketingBlocksModalConfig[modalKey];
    const dialogRef = this.dialog.open(config.component, {
      data: {
        parentId: recordData.id,
        [config.fieldName]: recordData[config.fieldName],
        modalKey: modalKey
      },
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openChangeRrcLimitModal(recordData: RecordData, modalKey: string): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(ChangeRrcLimitModalComponent, {
      data: {
        parentId: recordData.id,
        [modalKey]: recordData[modalKey],
        modalKey: modalKey
      },
      width: '450px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openEditorTextModal(textDialogData: EditorTextModalDialogData): Promise<CloseModalReason | void> {
    const dialogRef = this.dialog.open(EditorTextModalComponent, {
      data: textDialogData,
      width: '800px',
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openProductPackagesModal(columnKey: keyof typeof productPackagesModalConfig, recordData?: RecordData): Promise<CloseModalReason> | void {
    const config = productPackagesModalConfig[columnKey];
    const dialogRef = this.dialog.open(config.component, {
      data: {
        parentId: recordData?.['technicalParametersId'],
        data: recordData?.[config.fieldName],
        modalKey: config.fieldName
      },
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openCompetitorBrandsModal(columnKey: keyof typeof competitorBrandsModalConfig, recordData: RecordData): Promise<CloseModalReason> | void {
    const config = competitorBrandsModalConfig[columnKey];
    const dialogRef = this.dialog.open(config.component, {
      data: {
        parentId: recordData.id,
        [config.fieldName]: recordData[config.fieldName],
        modalKey: config.fieldName
      },
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openPriceLevelsModalConfigModal(columnKey: keyof typeof priceLevelsModalConfig, recordData: RecordData): Promise<CloseModalReason> | void {
    const config = priceLevelsModalConfig[columnKey];
    const dialogRef = this.dialog.open(config.component, {
      data: {
        parentId: recordData.id,
        [config.fieldName]: recordData[config.fieldName],
        modalKey: config.fieldName
      },
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openPriceLevelConfigsModal(columnKey: keyof typeof priceLevelConfigsModalConfig, recordData?: RecordData): Promise<CloseModalReason> | void {
    const config = priceLevelConfigsModalConfig[columnKey];
    const dialogRef = this.dialog.open(config.component, {
      data: {
        parentId: recordData?.id,
        [config.fieldName]: recordData?.[config.fieldName],
        modalKey: config.fieldName
      },
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openBaseConfirmModalComponent(params: DeleteConfirmationParams): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(BaseConfirmModalComponent, {
      data: {
        deleteConfirmationParams: params
      }
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openTestingResultFilesModal(columnKey: string, recordData: RecordData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(TestingResultFilesModalComponent, {
      data: {
        parentData: recordData,
        columnKey: columnKey,
        comment: (recordData['testingResultFiles'] as RecordData)['comment'],
      },
      width: '450px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openCreateComponentModal(productCardId: string): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(CreateComponentModalComponent, {
      data: { productCardId: Number(productCardId) },
      width: '450px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openCreateTestingResultModal(productCardId: string): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(CreateTestingResultModalComponent, {
      data: { productCardId: Number(productCardId) },
      width: '450px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openCreateQualityControlModal(columnKey: keyof typeof qualityControlModalConfig, parentId: string, columnsParams?: Array<RecordTableColumnParams>): Promise<CloseModalReason> | void {
    const config = qualityControlModalConfig[columnKey];

    const dialogRef = this.dialog.open(config.component, {
      data: {
        parentId: Number(parentId),
        ...(columnsParams?.length && { columnsParams: columnsParams })
      },
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openPriceLevelConfigCopyModal(data: PriceLevelConfigCopyDialogData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(PriceLevelConfigCopyModalComponent, {
      data: data,
      width: '450px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openRrcLimitsCopyModal(data: RrcLimitCopyDialogData): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(RrcLimitsCopyModalComponent, {
      data: data,
      width: '450px'
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  public openWildberriesProductCardsModal(columnKey: keyof typeof wildberriesProductCardsModalConfig, recordData: RecordData): Promise<CloseModalReason> | void {
    const config = wildberriesProductCardsModalConfig[columnKey];
    const dialogRef = this.dialog.open(config.component, {
      data: {
        [config.fieldName]: recordData?.[config.fieldName],
        modalKey: config.fieldName
      },
      width: config.width
    });

    return new Promise((resolve) =>
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => resolve(reason))
    );
  }

  private getParentInfoUpdateParams(columnParamKey: string, recordData: RecordData): ParentInfoUpdateParams | null {
    const targetResourceId: number | null = Number((recordData[columnParamKey] as RecordData)?.id) ?? null;
    if (targetResourceId) { return null; }

    return {
      parentPath: this.recordsTableService.getCurrentResourceType().path,
      parentId: +recordData.id,
      updateField: columnParamKey,
      parentData: recordData,
    };
  }
}
